import React from 'react';
import { Resume, SendLoanForm } from './index';
import { FormValues, BorrowerData, Ownership, SelectedIndexData } from '../../../types';
import { ONBOARDING_STEPS } from '../../../utils/constants';

interface LastStepsContainerProps {
  isMixedUseProperty: boolean;
  values: FormValues;
  setValue: (key: string, value: string | number) => void;
  setMultipleValues: (updates: Partial<FormValues>) => void;
  selectedIndex: number;
  setSelectedIndex: (index: number, options?: { force?: boolean }) => void;
  setSelectedIndexData: (data: SelectedIndexData) => void;
  setBottomValue: (value: number) => void;
  onFinish: () => void;
  isBrokerMode: boolean;
  isProcessingTeamMode: boolean;
  isBorrowerMode: boolean;
  setBorrowerData: (data: BorrowerData | null) => void;
  borrowerData: BorrowerData | null;
  ownerships: Ownership[];
}

export const LastStepsContainer: React.FC<LastStepsContainerProps> = ({
  isMixedUseProperty,
  values,
  setValue,
  setMultipleValues,
  selectedIndex,
  setSelectedIndex,
  setSelectedIndexData,
  setBottomValue,
  onFinish,
  isBrokerMode,
  isProcessingTeamMode,
  isBorrowerMode,
  setBorrowerData,
  borrowerData,
  ownerships,
}) => {
  if (isMixedUseProperty) {
    return (
      <React.Fragment>
        <Resume
          values={values}
          setValue={setValue}
          setMultipleValues={setMultipleValues}
          isSelected={selectedIndex === ONBOARDING_STEPS.length}
          setBottomValue={setBottomValue}
          setSelectedIndex={setSelectedIndex}
          setSelectedIndexData={setSelectedIndexData}
          onFinish={() => setSelectedIndex(ONBOARDING_STEPS.length + 1)}
          isBrokerMode={isBrokerMode}
          isProcessingTeamMode={isProcessingTeamMode}
          isBorrowerMode={isBorrowerMode}
          setBorrowerData={setBorrowerData}
          borrowerData={borrowerData}
          ownerships={ownerships}
          stepIndex={ONBOARDING_STEPS.length}
        />
        <SendLoanForm
          isSelected={selectedIndex === ONBOARDING_STEPS.length + 1}
          setBottomValue={setBottomValue}
        />
      </React.Fragment>
    );
  }

  return (
    <Resume
      values={values}
      setValue={setValue}
      setMultipleValues={setMultipleValues}
      isSelected={selectedIndex === ONBOARDING_STEPS.length}
      setBottomValue={setBottomValue}
      setSelectedIndex={setSelectedIndex}
      setSelectedIndexData={setSelectedIndexData}
      onFinish={onFinish}
      isBrokerMode={isBrokerMode}
      isProcessingTeamMode={isProcessingTeamMode}
      isBorrowerMode={isBorrowerMode}
      setBorrowerData={setBorrowerData}
      borrowerData={borrowerData}
      ownerships={ownerships}
      stepIndex={ONBOARDING_STEPS.length}
    />
  );
};

